<template>
  <vx-card title="Pagos realizados (Tesorería)">
    <vs-table :data="project.profile.transactions.items">
      <template slot="thead">
        <vs-th>ID</vs-th>
        <vs-th>TXR</vs-th>
        <vs-th>% de costo total</vs-th>
        <vs-th>Monto</vs-th>
        <vs-th>Concepto</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Creado</vs-th>
        <vs-th>Pagado</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="payment in data" v-bind:key="payment.id">
          <vs-td>{{ payment.id }}</vs-td>
          <vs-td>{{ payment.trxType }}</vs-td>
          <vs-td>{{ project.calculatePercentage(payment.amount) }}</vs-td>
          <vs-td>{{ payment.amount|currency }}</vs-td>
          <vs-td>{{ payment.concept }}</vs-td>
          <vs-td>
              <span class="label" :class="{
                'label-danger': (payment.status === 1 || payment.status === 5),
                'label-warning': payment.status === 2,
                'label-success': payment.status === 3
              }">
              {{ payment.status|translate }}
            </span>
          </vs-td>
          <vs-td>{{ payment.createdAt | humanizeDate }}</vs-td>
          <vs-td>{{ payment.trxConfirmationDate | humanizeDate }}</vs-td>
        </vs-tr>
      </template>
      <vs-tr style="background: #000; color: #FFF;">
        <vs-td colspan="2">
          TOTAL
        </vs-td>
        <vs-td>{{ project.profile.transactions.totalPercentage(project.totalCost) }} %</vs-td>
        <vs-td colspan="6"></vs-td>
      </vs-tr>
    </vs-table>
  </vx-card>
</template>

<script>
import {_humanizeDate} from "@/filters/momentTzConvert";
import {LoanProject} from "@/models/LoanPayment/Project";

export default {
  name: "loan-transaction-card",
  props: {
    project: {
      type: LoanProject,
      required: true
    }
  },
  filters: {
    humanizeDate: _humanizeDate,
    translate(status) {
      switch (status) {
        case 1:
          return "Pendiente";
        case 2:
          return "Pago en proceso";
        case 3:
          return "Pagado";
        case 5:
          return "Devuelto"
      }
    }
  },
}
</script>

<style scoped>

</style>
